import { render, staticRenderFns } from "./UsageList.vue?vue&type=template&id=06560ca6&"
import script from "./UsageList.vue?vue&type=script&lang=ts&"
export * from "./UsageList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports